import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategoriesDesktop from './CategoriesDesktop';
import CategoriesMobile from './CategoriesMobile';
import TagsDesktop from './TagsDesktop';
import TagsMobile from './TagsMobile';
import CategoriesDetal from './CategoriesDetal';
import SortMobile from './SortMobile';
import { getContestCategoties } from '../../utils/api/services/contest';
import { getContestTags } from '../../utils/api/services/contest';
import practiceConstants from './practiceConstants';

export default class CategoriesAndTagsPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      tags: [],
    };
  }

  static propTypes = {
    onChangeCategory: PropTypes.func.isRequired,
    onChangeTags: PropTypes.func.isRequired,
    onChangeSort: PropTypes.func.isRequired,
    isLoadingSelectedTags: PropTypes.bool
  };

  componentWillMount = () => {
    this.fetchCategotiesData();
    this.fetchTagsData();
  }

  fetchCategotiesData = () => {
    getContestCategoties()
      .then((result) => {
        this.setState({
          categories: result,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  fetchTagsData = () => {
    getContestTags()
      .then((result) => {
        this.setState({
          tags: result,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  changeCategory = (category) => {
    this.props.onChangeCategory(category.alias);
  }

  changeTags = (tags) => {
    this.props.onChangeTags(tags);
  }

  changeSort = (sort) => {
    this.props.onChangeSort(sort);
  }

  render() {
    const {
      categories, tags,
    } = this.state;

    const {
      selectedCategoryAlias, selectedSortAlias, selectedTags, isLoadingSelectedTags
    } = this.props;

    const selectedCategory = categories.find(el => el.alias === selectedCategoryAlias) || practiceConstants.allCategory;
    const selectedSort = practiceConstants.sortTypes.find(el => el.alias === selectedSortAlias) || practiceConstants.sortTypes[0];

    return (
      <React.Fragment>
        <div className="box -simple -apart-row mobile-hide">
          <CategoriesDesktop
            categories={categories}
            selectedCategory={selectedCategory}
            onChangeCategory={this.changeCategory} />
          <TagsDesktop
            tags={tags}
            selectedTags={selectedTags}
            onChangeTags={this.changeTags} />
          <CategoriesDetal
            selectedSort={selectedSort}
            selectedCategory={selectedCategory}
            onChangeSort={this.changeSort} />
        </div>

        <div className="mobile-show">
          <CategoriesMobile
            categories={categories}
            selectedCategory={selectedCategory}
            onChangeCategory={this.changeCategory} />
          <TagsMobile
            tags={tags}
            selectedTags={selectedTags}
            onChangeTags={this.changeTags}
            isLoadingSelectedTags={isLoadingSelectedTags}
            />
          <SortMobile
            selectedSort={selectedSort}
            onChangeSort={this.changeSort} />
        </div>
      </React.Fragment>
    );
  }
}
